import { useMutation, useQuery, useQueryClient } from "react-query";
import React from "react";
import * as wf from "@qpr/client-api-workflow";
import createUICardElement from "backend/utils/createUICardElement";

const useAllWorkflowInstances = (type: string, period: string) => {
  return useQuery(
    JSON.stringify(["data-all-workflow-instances", type, period]),
    () => {
      return wf
        .getAllInstances(type, period)
        .then((data) =>
          data.map((item) =>
            createUICardElement(item.wfInstanceId, "workflowinstance", item)
          )
        );
    },
    {
      cacheTime: 1 * 1000,
    }
  );
};

export default useAllWorkflowInstances;
